module.exports = __webpack_public_path__ + "static/media/slider_active_yl.fe2c912b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider_active_yl.svg
// module id = 29
// module chunks = 0